import { ServiceRoute, GLServiceBase } from "gl-commonui";
import { ISearchService } from "./interface";
import { SearchRequest, SearchModel } from "./model";

export class SearchService
    extends GLServiceBase<SearchRequest, any>
    implements ISearchService
{
    serviceRoute: ServiceRoute = { prefix: "admin/v1/resources/hybrid" };
    search(params: any) {
        // Obsolete code, for reference only, will be removed in the future
        return this.request.get(this.url(""), params) as Promise<SearchModel[]>;
    }
    searchStructure(params: any) {
        const suffix = params.__gl_region__ ? 'aggregation-v2?__gl_region__=' + params.__gl_region__ : 'aggregation-v2';
        const { __gl_region__, ...body } = params;
        return this.request.post(this.url(suffix), body) as Promise<SearchModel[]>;
    }
}
